import ReactModal from 'react-modal';

import { observer } from 'mobx-react-lite';

import CoreThemeBridge from './CoreThemeBridge';

import { FANCY_SHADOW, MODAL_RADIUS } from '../styles/constants';

ReactModal.setAppElement('#root');

function Modal({ components, store }) {
  const { modalType, modalProps } = store;

  function closeModal() {
    if (modalProps && modalProps.onCloseModal) {
      modalProps.onCloseModal();
    }
    store.hide();
  }

  let modalStyles = {
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(49,47,76,0.5)',
      zIndex: 1000,
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
    content: {
      top: 'auto',
      left: 'auto',
      right: 'auto',
      bottom: 'auto',
      width: '620px',
      maxWidth: '98%',
      maxHeight: '98%',
      boxShadow: FANCY_SHADOW,
      borderRadius: MODAL_RADIUS,
      border: 'none',
      padding: '40px',
      overflow: 'auto',
      margin: '0 auto',
    },
  };

  if (store.size === 'fullscreen') {
    modalStyles.overlay.backgroundColor = '#3C3C64';
    modalStyles.content.maxWidth = '100%';
    modalStyles.content.maxHeight = '100%';
    modalStyles.content.width = '100%';
    modalStyles.content.height = '100%';
    modalStyles.content.backgroundColor = '#3C3C64';
    modalStyles.content.borderRadius = '0';
    modalStyles.content.border = 'none';
    modalStyles.content.padding = '0';
  }
  let closeOnOverlayOrEsc = false;

  const SpecificModal = components[modalType];

  if (modalProps) {
    if (modalProps.width) {
      modalStyles.content.width = modalProps.width;
    }
    if (modalProps.autoWidth) {
      modalStyles.content.width = 'auto';
    }
    if (modalProps.minWidth) {
      modalStyles.content.minWidth = modalProps.minWidth;
    }
    if (modalProps.overflow) {
      modalStyles.content.overflow = modalProps.overflow;
    }
    if (modalProps.closeOnOverlayClickOrEsc !== undefined) {
      closeOnOverlayOrEsc = modalProps.closeOnOverlayClickOrEsc;
    }
  }

  return (
    <ReactModal
      style={modalStyles}
      isOpen={modalType !== ''}
      contentLabel="Modal"
      onRequestClose={closeModal}
      parentSelector={() => document.getElementById('root')}
      shouldCloseOnOverlayClick={closeOnOverlayOrEsc}
      shouldCloseOnEsc={closeOnOverlayOrEsc}
    >
      <div id="modal">
        <CoreThemeBridge>
          {SpecificModal && <SpecificModal {...modalProps} closeModal={closeModal} />}
        </CoreThemeBridge>
      </div>
    </ReactModal>
  );
}

export default observer(Modal);
